export default __webpack_public_path__ + "static/media/camera.382de66e.svg";